import { ClassTimestampsHelper } from '../ClassHelper';
import Account from '../account/Account';

class Subdivision extends ClassTimestampsHelper {
  constructor({ account, title, status, phones = [], disabledPaymentMethods = [], noDiscount = false, ...other } = {}) {
    super(...arguments);
    this.account = this.ref(account, Account);
    this.title = title;
    this.status = status; // Status
    this.phones = phones;
    this.disabledPaymentMethods = disabledPaymentMethods;
    this.noDiscount = noDiscount;
  }
}

export default Subdivision;